/* eslint-disable max-len */
import {
  SET_COOKIE_POLICY_ACCEPTED,
} from '../../constants'

export default function CookiePolicyAcceptanceReducer(state = { cookieSeen: true }, { type, cookieSeen } = {}) {
  switch (type) {
    case SET_COOKIE_POLICY_ACCEPTED: {
      return {
        ...state,
        cookieSeen,
      }
    }
    default:
      return state
  }
}
